import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 400px;
  margin: 15px 0;
`;

export {
  Container,
};
